import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import introduction from '@/components/introduction'
import project from '@/components/project'
import project2 from '@/components/project2'
import ceo from '@/components/ceo'
import call from '@/components/call'
import news from '@/components/news'
import qualification from '@/components/qualification'
import qualification2 from '@/components/qualification2'
import qualification3 from '@/components/qualification3'
import qualification4 from '@/components/qualification4'
import architecture from '@/components/architecture'
import architecture2 from '@/components/architecture2'
import traffic from '@/components/traffic'
import security from '@/components/security'
import air from '@/components/air'
import jianzhu from '@/components/jianzhu'
import technology from '@/components/technology'
import monitor from '@/components/monitor'
import administration from '@/components/administration'
import newdetailed from '@/components/newdetailed'
import test from '@/components/test'
import newstitle from '../components/newstitle.vue'
import news1 from '../components/news/news1.vue'
import news2 from '../components/news/news2.vue'

import news3 from '../components/news/news3.vue'

import news4 from '../components/news/news4.vue'
import gps from '@/components/gps.vue'

Vue.use(Router)

export default new Router({
    mode:"hash",
    routes:[
        {
            path:'/gps',
            component:gps
        },
        {
            path:'/',
            component:index,
        },
        {
            path:'newstitle',
            component:newstitle
        },
        {
            path:'/jianzhu',
            component:jianzhu,
        },
        {
            path:'/newdetailed/:previousRoute',
            component:newdetailed,
        },
        {
            path:'/air',
            component:air,
        },
        {
            path:'/technology',
            component:technology,
        },
        {
            path:'/monitor',
            component:monitor,
        },
        {
            path:'/administration',
            component:administration,
        },
        {
            path:'/air',
            component:air,
        },
        // {
        //     path:'/new1',
        //     component:news1,
        // },
        {
            path:'/news',
            component:news,
            redirect:'/news/news1',

            children:[
                {
                    path:'news1',
                    component:news1,
                },
                {
                    path:'news2',
                    component:news2,
                },
                {
                    path:'news3',
                    component:news3,
                },
                {
                    path:'news4',
                    component:news4,
                },
            ]
        },
        {
            path:'/call',
            component:call
        },
        {
            path:'/ceo',
            component:ceo
        },
        {
            path:'/introduction',
            component:introduction
        },
        {
            path:'/project',
            component:project
        },
        {
            path: '/project/building/:tabId?',
            component: project
        },
        {
            path:'/project2',
            component:project2
        },
        {
            path:'/qualification',
            component:qualification
        },
        {
            path:'/qualification2',
            component:qualification2
        },
        {
            path:'/qualification3',
            component:qualification3
        },
        {
            path:'/qualification4',
            component:qualification4
        },

        {
            path:'/architecture',
            component:architecture
        },
        {
            path:'/architecture2',
            component:architecture2
        },

        {
            path:'/traffic',
            component:traffic
        },
        {
            path:'/security',
            component:security
        },
        {
            path:'/test',
            component:test
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js